import React from "react";
import { Subscribe } from 'unstated';
import OrganizationContainer from "../../../../../shared/state/containers/OrganizationContainer";
import MediaContainer from "../../../../../shared/state/containers/MediaContainer";
import MemberContainer from "../../../../../shared/state/containers/MemberContainer";
import UserContainer from "../../../../../shared/state/containers/UserContainer";
import OrganizationSettingsTabs from "./OrganizationSettingsTabs";
import ApplicationContainer from "../../../../../shared/state/containers/ApplicationContainer";
import ApiKeyContainer from "../../../../../shared/state/containers/ApiKeyContainer";
import ApplicationModel from "../../../../../shared/models/applications/api/ApplicationModel";
import TemplateFormSectionModel from "../../../../../shared/models/templating/api/TemplateFormSectionModel";
import TemplateFormFieldModel from "../../../../../shared/models/templating/api/TemplateFormFieldModel";
import TemplateConfigurationContainer from "../../../../../shared/state/containers/TemplateConfigurationContainer";
import AppliedApplicationTemplateContainer from "../../../../../shared/state/containers/AppliedApplicationTemplateContainer";
import ApplicationEnvironmentsContainer from "../../../../../shared/state/containers/ApplicationEnvironmentsContainer";

interface OrganizationSettingsProps {
    commonApp: ApplicationModel;
    locationApps: ApplicationModel[];
    manageMenuApps?: ApplicationModel[];
    locationAppNames: string[];
    commonAppSections: TemplateFormSectionModel[];
    locationAppFormFields: TemplateFormFieldModel[];
    isLoadingTemplates: boolean;
    history: any;
    hideApplicationSettings?: boolean;
}

const OrganizationSettings: React.FC<OrganizationSettingsProps> = (props) => (
    <Subscribe to={
        [OrganizationContainer,
            MediaContainer,
            MemberContainer,
            UserContainer,
            ApplicationContainer,
            ApiKeyContainer,
            TemplateConfigurationContainer,
            AppliedApplicationTemplateContainer,
            ApplicationEnvironmentsContainer]
    }>
        {(orgContainer: OrganizationContainer,
            mediaContainer: MediaContainer,
            memberContainer: MemberContainer,
            userContainer: UserContainer,
            appContainer: ApplicationContainer,
            apiKeyContainer: ApiKeyContainer,
            templateConfigurationContainer: TemplateConfigurationContainer,
            appliedTemplateContainer: AppliedApplicationTemplateContainer,
            applicationEnvironmentsContainer: ApplicationEnvironmentsContainer
        ) => {
            return (
                <OrganizationSettingsTabs
                    orgContainer={orgContainer}
                    mediaContainer={mediaContainer}
                    memberContainer={memberContainer}
                    userContainer={userContainer}
                    appContainer={appContainer}
                    apiKeyContainer={apiKeyContainer}
                    commonApp={props.commonApp}
                    locationApps={props.locationApps}
                    manageMenuApps={props.manageMenuApps}
                    locationAppNames={props.locationAppNames}
                    commonAppSections={props.commonAppSections}
                    locationAppFormFields={props.locationAppFormFields}
                    isLoadingTemplates={props.isLoadingTemplates}
                    history={props.history}
                    hideApplicationSettings={props.hideApplicationSettings}
                    templateConfigurationContainer={templateConfigurationContainer}
                    appliedTemplateContainer={appliedTemplateContainer}
                    applicationEnvironmentsContainer={applicationEnvironmentsContainer}
                />
            );
        }}
    </Subscribe>
);

export default OrganizationSettings;
